// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v7.35.1
// source: odoo/sessionkv.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "pc.proto.odoo.sessionkv";

/** used to dump the entire available session store to the frontend */
export interface SessionValueStore {
  entries: SessionValueStoreEntry[];
}

/** single row/entry in the store. name is used for addressing when updating an entry */
export interface SessionValueStoreEntry {
  name: string;
  value?: { $case: "portOrder"; portOrder: PortOrder } | undefined;
}

export interface PortOrder {
  applianceId: number;
  /** only filled, if a reseller wants to send a quotation to a certain contact */
  contactId: number;
  numberBlocks?:
    | { $case: "singleNumbers"; singleNumbers: PortOrder_SingleNumberPortEntries }
    | { $case: "numberBlock"; numberBlock: PortOrder_NumberBlockPortEntry }
    | undefined;
  /** "Deutsche Telekom GmbH" */
  losingProvider: string;
  losingProviderPhoneBill?: PortOrder_FileAttachment | undefined;
}

export interface PortOrder_FileAttachment {
  /** ULID from MD-18299 */
  assetKey: string;
}

export interface PortOrder_SingleNumberPortEntries {
  phoneNumbers: PortOrder_SingleNumberPortEntries_SingleNumberPortEntry[];
}

export interface PortOrder_SingleNumberPortEntries_SingleNumberPortEntry {
  /** 0049 */
  countryPrefix: string;
  /** 991 */
  areaCode: string;
  /** 4711 */
  number: string;
}

export interface PortOrder_NumberBlockPortEntry {
  /** 0049 */
  countryPrefix: string;
  /** 991 */
  areaCode: string;
  /** 4711 */
  mainNumber: string;
  /** 00 */
  blockStart: string;
  /** 99 */
  blockEnd: string;
}

function createBaseSessionValueStore(): SessionValueStore {
  return { entries: [] };
}

export const SessionValueStore: MessageFns<SessionValueStore> = {
  encode(message: SessionValueStore, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entries) {
      SessionValueStoreEntry.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SessionValueStore {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSessionValueStore();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entries.push(SessionValueStoreEntry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SessionValueStore {
    return {
      entries: globalThis.Array.isArray(object?.entries)
        ? object.entries.map((e: any) => SessionValueStoreEntry.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SessionValueStore): unknown {
    const obj: any = {};
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => SessionValueStoreEntry.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SessionValueStore>, I>>(base?: I): SessionValueStore {
    return SessionValueStore.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SessionValueStore>, I>>(object: I): SessionValueStore {
    const message = createBaseSessionValueStore();
    message.entries = object.entries?.map((e) => SessionValueStoreEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSessionValueStoreEntry(): SessionValueStoreEntry {
  return { name: "", value: undefined };
}

export const SessionValueStoreEntry: MessageFns<SessionValueStoreEntry> = {
  encode(message: SessionValueStoreEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    switch (message.value?.$case) {
      case "portOrder":
        PortOrder.encode(message.value.portOrder, writer.uint32(18).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SessionValueStoreEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSessionValueStoreEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = { $case: "portOrder", portOrder: PortOrder.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SessionValueStoreEntry {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object.portOrder)
        ? { $case: "portOrder", portOrder: PortOrder.fromJSON(object.portOrder) }
        : undefined,
    };
  },

  toJSON(message: SessionValueStoreEntry): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value?.$case === "portOrder") {
      obj.portOrder = PortOrder.toJSON(message.value.portOrder);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SessionValueStoreEntry>, I>>(base?: I): SessionValueStoreEntry {
    return SessionValueStoreEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SessionValueStoreEntry>, I>>(object: I): SessionValueStoreEntry {
    const message = createBaseSessionValueStoreEntry();
    message.name = object.name ?? "";
    switch (object.value?.$case) {
      case "portOrder": {
        if (object.value?.portOrder !== undefined && object.value?.portOrder !== null) {
          message.value = { $case: "portOrder", portOrder: PortOrder.fromPartial(object.value.portOrder) };
        }
        break;
      }
    }
    return message;
  },
};

function createBasePortOrder(): PortOrder {
  return {
    applianceId: 0,
    contactId: 0,
    numberBlocks: undefined,
    losingProvider: "",
    losingProviderPhoneBill: undefined,
  };
}

export const PortOrder: MessageFns<PortOrder> = {
  encode(message: PortOrder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.applianceId !== 0) {
      writer.uint32(8).int64(message.applianceId);
    }
    if (message.contactId !== 0) {
      writer.uint32(16).int64(message.contactId);
    }
    switch (message.numberBlocks?.$case) {
      case "singleNumbers":
        PortOrder_SingleNumberPortEntries.encode(message.numberBlocks.singleNumbers, writer.uint32(26).fork()).join();
        break;
      case "numberBlock":
        PortOrder_NumberBlockPortEntry.encode(message.numberBlocks.numberBlock, writer.uint32(34).fork()).join();
        break;
    }
    if (message.losingProvider !== "") {
      writer.uint32(42).string(message.losingProvider);
    }
    if (message.losingProviderPhoneBill !== undefined) {
      PortOrder_FileAttachment.encode(message.losingProviderPhoneBill, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortOrder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortOrder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.applianceId = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.contactId = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.numberBlocks = {
            $case: "singleNumbers",
            singleNumbers: PortOrder_SingleNumberPortEntries.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.numberBlocks = {
            $case: "numberBlock",
            numberBlock: PortOrder_NumberBlockPortEntry.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.losingProvider = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.losingProviderPhoneBill = PortOrder_FileAttachment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortOrder {
    return {
      applianceId: isSet(object.applianceId) ? globalThis.Number(object.applianceId) : 0,
      contactId: isSet(object.contactId) ? globalThis.Number(object.contactId) : 0,
      numberBlocks: isSet(object.singleNumbers)
        ? { $case: "singleNumbers", singleNumbers: PortOrder_SingleNumberPortEntries.fromJSON(object.singleNumbers) }
        : isSet(object.numberBlock)
        ? { $case: "numberBlock", numberBlock: PortOrder_NumberBlockPortEntry.fromJSON(object.numberBlock) }
        : undefined,
      losingProvider: isSet(object.losingProvider) ? globalThis.String(object.losingProvider) : "",
      losingProviderPhoneBill: isSet(object.losingProviderPhoneBill)
        ? PortOrder_FileAttachment.fromJSON(object.losingProviderPhoneBill)
        : undefined,
    };
  },

  toJSON(message: PortOrder): unknown {
    const obj: any = {};
    if (message.applianceId !== 0) {
      obj.applianceId = Math.round(message.applianceId);
    }
    if (message.contactId !== 0) {
      obj.contactId = Math.round(message.contactId);
    }
    if (message.numberBlocks?.$case === "singleNumbers") {
      obj.singleNumbers = PortOrder_SingleNumberPortEntries.toJSON(message.numberBlocks.singleNumbers);
    } else if (message.numberBlocks?.$case === "numberBlock") {
      obj.numberBlock = PortOrder_NumberBlockPortEntry.toJSON(message.numberBlocks.numberBlock);
    }
    if (message.losingProvider !== "") {
      obj.losingProvider = message.losingProvider;
    }
    if (message.losingProviderPhoneBill !== undefined) {
      obj.losingProviderPhoneBill = PortOrder_FileAttachment.toJSON(message.losingProviderPhoneBill);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortOrder>, I>>(base?: I): PortOrder {
    return PortOrder.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortOrder>, I>>(object: I): PortOrder {
    const message = createBasePortOrder();
    message.applianceId = object.applianceId ?? 0;
    message.contactId = object.contactId ?? 0;
    switch (object.numberBlocks?.$case) {
      case "singleNumbers": {
        if (object.numberBlocks?.singleNumbers !== undefined && object.numberBlocks?.singleNumbers !== null) {
          message.numberBlocks = {
            $case: "singleNumbers",
            singleNumbers: PortOrder_SingleNumberPortEntries.fromPartial(object.numberBlocks.singleNumbers),
          };
        }
        break;
      }
      case "numberBlock": {
        if (object.numberBlocks?.numberBlock !== undefined && object.numberBlocks?.numberBlock !== null) {
          message.numberBlocks = {
            $case: "numberBlock",
            numberBlock: PortOrder_NumberBlockPortEntry.fromPartial(object.numberBlocks.numberBlock),
          };
        }
        break;
      }
    }
    message.losingProvider = object.losingProvider ?? "";
    message.losingProviderPhoneBill =
      (object.losingProviderPhoneBill !== undefined && object.losingProviderPhoneBill !== null)
        ? PortOrder_FileAttachment.fromPartial(object.losingProviderPhoneBill)
        : undefined;
    return message;
  },
};

function createBasePortOrder_FileAttachment(): PortOrder_FileAttachment {
  return { assetKey: "" };
}

export const PortOrder_FileAttachment: MessageFns<PortOrder_FileAttachment> = {
  encode(message: PortOrder_FileAttachment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.assetKey !== "") {
      writer.uint32(10).string(message.assetKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortOrder_FileAttachment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortOrder_FileAttachment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assetKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortOrder_FileAttachment {
    return { assetKey: isSet(object.assetKey) ? globalThis.String(object.assetKey) : "" };
  },

  toJSON(message: PortOrder_FileAttachment): unknown {
    const obj: any = {};
    if (message.assetKey !== "") {
      obj.assetKey = message.assetKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortOrder_FileAttachment>, I>>(base?: I): PortOrder_FileAttachment {
    return PortOrder_FileAttachment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortOrder_FileAttachment>, I>>(object: I): PortOrder_FileAttachment {
    const message = createBasePortOrder_FileAttachment();
    message.assetKey = object.assetKey ?? "";
    return message;
  },
};

function createBasePortOrder_SingleNumberPortEntries(): PortOrder_SingleNumberPortEntries {
  return { phoneNumbers: [] };
}

export const PortOrder_SingleNumberPortEntries: MessageFns<PortOrder_SingleNumberPortEntries> = {
  encode(message: PortOrder_SingleNumberPortEntries, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.phoneNumbers) {
      PortOrder_SingleNumberPortEntries_SingleNumberPortEntry.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortOrder_SingleNumberPortEntries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortOrder_SingleNumberPortEntries();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.phoneNumbers.push(
            PortOrder_SingleNumberPortEntries_SingleNumberPortEntry.decode(reader, reader.uint32()),
          );
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortOrder_SingleNumberPortEntries {
    return {
      phoneNumbers: globalThis.Array.isArray(object?.phoneNumbers)
        ? object.phoneNumbers.map((e: any) => PortOrder_SingleNumberPortEntries_SingleNumberPortEntry.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PortOrder_SingleNumberPortEntries): unknown {
    const obj: any = {};
    if (message.phoneNumbers?.length) {
      obj.phoneNumbers = message.phoneNumbers.map((e) =>
        PortOrder_SingleNumberPortEntries_SingleNumberPortEntry.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortOrder_SingleNumberPortEntries>, I>>(
    base?: I,
  ): PortOrder_SingleNumberPortEntries {
    return PortOrder_SingleNumberPortEntries.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortOrder_SingleNumberPortEntries>, I>>(
    object: I,
  ): PortOrder_SingleNumberPortEntries {
    const message = createBasePortOrder_SingleNumberPortEntries();
    message.phoneNumbers =
      object.phoneNumbers?.map((e) => PortOrder_SingleNumberPortEntries_SingleNumberPortEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBasePortOrder_SingleNumberPortEntries_SingleNumberPortEntry(): PortOrder_SingleNumberPortEntries_SingleNumberPortEntry {
  return { countryPrefix: "", areaCode: "", number: "" };
}

export const PortOrder_SingleNumberPortEntries_SingleNumberPortEntry: MessageFns<
  PortOrder_SingleNumberPortEntries_SingleNumberPortEntry
> = {
  encode(
    message: PortOrder_SingleNumberPortEntries_SingleNumberPortEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.countryPrefix !== "") {
      writer.uint32(10).string(message.countryPrefix);
    }
    if (message.areaCode !== "") {
      writer.uint32(18).string(message.areaCode);
    }
    if (message.number !== "") {
      writer.uint32(26).string(message.number);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortOrder_SingleNumberPortEntries_SingleNumberPortEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortOrder_SingleNumberPortEntries_SingleNumberPortEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.countryPrefix = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.areaCode = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.number = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortOrder_SingleNumberPortEntries_SingleNumberPortEntry {
    return {
      countryPrefix: isSet(object.countryPrefix) ? globalThis.String(object.countryPrefix) : "",
      areaCode: isSet(object.areaCode) ? globalThis.String(object.areaCode) : "",
      number: isSet(object.number) ? globalThis.String(object.number) : "",
    };
  },

  toJSON(message: PortOrder_SingleNumberPortEntries_SingleNumberPortEntry): unknown {
    const obj: any = {};
    if (message.countryPrefix !== "") {
      obj.countryPrefix = message.countryPrefix;
    }
    if (message.areaCode !== "") {
      obj.areaCode = message.areaCode;
    }
    if (message.number !== "") {
      obj.number = message.number;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortOrder_SingleNumberPortEntries_SingleNumberPortEntry>, I>>(
    base?: I,
  ): PortOrder_SingleNumberPortEntries_SingleNumberPortEntry {
    return PortOrder_SingleNumberPortEntries_SingleNumberPortEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortOrder_SingleNumberPortEntries_SingleNumberPortEntry>, I>>(
    object: I,
  ): PortOrder_SingleNumberPortEntries_SingleNumberPortEntry {
    const message = createBasePortOrder_SingleNumberPortEntries_SingleNumberPortEntry();
    message.countryPrefix = object.countryPrefix ?? "";
    message.areaCode = object.areaCode ?? "";
    message.number = object.number ?? "";
    return message;
  },
};

function createBasePortOrder_NumberBlockPortEntry(): PortOrder_NumberBlockPortEntry {
  return { countryPrefix: "", areaCode: "", mainNumber: "", blockStart: "", blockEnd: "" };
}

export const PortOrder_NumberBlockPortEntry: MessageFns<PortOrder_NumberBlockPortEntry> = {
  encode(message: PortOrder_NumberBlockPortEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.countryPrefix !== "") {
      writer.uint32(10).string(message.countryPrefix);
    }
    if (message.areaCode !== "") {
      writer.uint32(18).string(message.areaCode);
    }
    if (message.mainNumber !== "") {
      writer.uint32(26).string(message.mainNumber);
    }
    if (message.blockStart !== "") {
      writer.uint32(34).string(message.blockStart);
    }
    if (message.blockEnd !== "") {
      writer.uint32(42).string(message.blockEnd);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortOrder_NumberBlockPortEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortOrder_NumberBlockPortEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.countryPrefix = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.areaCode = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mainNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.blockStart = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.blockEnd = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortOrder_NumberBlockPortEntry {
    return {
      countryPrefix: isSet(object.countryPrefix) ? globalThis.String(object.countryPrefix) : "",
      areaCode: isSet(object.areaCode) ? globalThis.String(object.areaCode) : "",
      mainNumber: isSet(object.mainNumber) ? globalThis.String(object.mainNumber) : "",
      blockStart: isSet(object.blockStart) ? globalThis.String(object.blockStart) : "",
      blockEnd: isSet(object.blockEnd) ? globalThis.String(object.blockEnd) : "",
    };
  },

  toJSON(message: PortOrder_NumberBlockPortEntry): unknown {
    const obj: any = {};
    if (message.countryPrefix !== "") {
      obj.countryPrefix = message.countryPrefix;
    }
    if (message.areaCode !== "") {
      obj.areaCode = message.areaCode;
    }
    if (message.mainNumber !== "") {
      obj.mainNumber = message.mainNumber;
    }
    if (message.blockStart !== "") {
      obj.blockStart = message.blockStart;
    }
    if (message.blockEnd !== "") {
      obj.blockEnd = message.blockEnd;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortOrder_NumberBlockPortEntry>, I>>(base?: I): PortOrder_NumberBlockPortEntry {
    return PortOrder_NumberBlockPortEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortOrder_NumberBlockPortEntry>, I>>(
    object: I,
  ): PortOrder_NumberBlockPortEntry {
    const message = createBasePortOrder_NumberBlockPortEntry();
    message.countryPrefix = object.countryPrefix ?? "";
    message.areaCode = object.areaCode ?? "";
    message.mainNumber = object.mainNumber ?? "";
    message.blockStart = object.blockStart ?? "";
    message.blockEnd = object.blockEnd ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
